import { ProductMessage } from '../../../types/ProductMessage';
import { VesselTankMessage } from '../../../types/VesselTankMessage';
import { useVesselTanks } from '../../order/create/hooks/useVesselTanks';

import { useRole } from './useRole';

interface UseVesselDefaultProductsOptions {
    vesselId?: string;
    enabled?: boolean;
}

export const useVesselDefaultProducts = ({ vesselId, enabled = true }: UseVesselDefaultProductsOptions) => {
    const role = useRole();

    const vesselTanksQuery = useVesselTanks({
        vesselId: vesselId!,
        enabled: !!(role.isCustomer() && enabled && vesselId),
    });

    const defaultProductsFromTanks = vesselTanksQuery.data?.vesselTanks
        ?.map((tank: VesselTankMessage) => tank.defaultProduct)
        .filter(Boolean);

    const uniqueDefaultProducts = defaultProductsFromTanks?.length
        ? defaultProductsFromTanks.reduce((acc: ProductMessage[], current: ProductMessage) => {
              if (!acc.map((product) => product.id).includes(current.id)) {
                  acc.push(current);
              }
              return acc;
          }, [])
        : [];

    return uniqueDefaultProducts.length ? uniqueDefaultProducts : undefined;
};
